import React, { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ChannelIcon } from './ChannelIcon';
import { ChannelIconsContainer, List, ListItem, PreviousChannelSelection, PreviousSelectedChannelLink, StyledChannelSelector } from './ChannelSelector.styles';
import { HorizontalScroller } from '../../../components/HorizontalScroller/HorizontalScroller';
import { useDataDispatch, useDataState } from '../../../providers/DataProvider/DataContext';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ChannelSelector = ({
  channels,
  activeChannelId,
  onChannelSelect
}) => {
  const {
    t
  } = useTranslation();
  const dataDispatch = useDataDispatch();
  const {
    channelHistory
  } = useDataState();
  const [activeElement, setActiveElement] = useState(undefined);
  const previousSelectedChannels = channelHistory.map(channelHistoryId => channels.find(channel => channel.id === channelHistoryId)).filter(channel => !!channel);
  const onChannelClick = clickedChannel => {
    onChannelSelect(clickedChannel);
    dataDispatch({
      type: 'add-channel-history',
      channel: clickedChannel
    });
  };
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(StyledChannelSelector, {
      children: /*#__PURE__*/_jsx(ChannelIconsContainer, {
        children: /*#__PURE__*/_jsx(HorizontalScroller, {
          activeElement: activeElement,
          children: /*#__PURE__*/_jsx(List, {
            children: channels.map(channel => /*#__PURE__*/_jsx(ListItem, {
              ref: element => {
                if (channel.id === activeChannelId && element) {
                  setActiveElement(element);
                }
              },
              children: /*#__PURE__*/_jsx(ChannelIcon, {
                channel: channel,
                isActive: channel.id === activeChannelId,
                onClick: () => onChannelClick(channel)
              })
            }, channel.id))
          })
        })
      })
    }), !!previousSelectedChannels.length && /*#__PURE__*/_jsxs(PreviousChannelSelection, {
      children: [/*#__PURE__*/_jsxs("span", {
        children: [t('tvGuide.previouslySelected'), ":\xA0"]
      }), previousSelectedChannels.map(channel => /*#__PURE__*/_jsx(PreviousSelectedChannelLink, {
        type: "text",
        onClick: () => onChannelClick(channel),
        text: channel.title
      }, channel.id))]
    })]
  });
};